module.exports = __webpack_public_path__ + "static/media/cake4_tn.d27f6c38.jpg";